import React from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import PDFDocument from './Document';

interface DownloadPDFButtonProps {
  headerData: Record<string, string>;
  data?: Record<string, any>[] | null;
  tableHeaders: any;
}

const DownloadPDFButton = ({
  headerData,
  data,
  tableHeaders,
}: DownloadPDFButtonProps) => {
  if (data.length === 0)
    return (
      <div className="flex flex-row justify-center items-center">
        <span className="text-sm text-red-500">
          No hay datos para crear el reporte
        </span>
      </div>
    );

  return (
    <button
      type="button"
      className="py-2 rounded tracking-wide transition-colors w-full whitespace-nowrap px-10 bg-purple-300 text-system-100 hover:bg-color-primary-200 font-normal border-0"
    >
      <PDFDownloadLink
        className="px-[12vw] py-2"
        document={
          <PDFDocument
            headerData={headerData}
            data={data}
            tableHeaders={tableHeaders}
          />
        }
        fileName="report_meit.pdf"
      >
        Descargar PDF
      </PDFDownloadLink>
    </button>
  );
};

export default DownloadPDFButton;
